import { LanguageKeys } from 'src/common/constants/languages';
import PageBlockShell from 'src/common/components/page-blocks/PageBlockShell';
import RichTextImage from 'src/common/components/RichTextImage';
import StackedGalleryThumbnail from 'src/common/components/page-blocks/StackedGalleryThumbnail';
import {
  imageDisplayOptionsToClassName,
  imageDisplayOptionsToExplicitSx,
  resolveGalleryItemAlt,
  resolveImageBlockAlt,
} from 'src/helpers/pageBlockImageUtils';
import { IImageBlock } from 'src/interfaces/PageBlock';

interface Props {
  block: IImageBlock;
  lang: LanguageKeys;
}

export default function ImageBlockContent({ block, lang }: Props) {
  const display = block.display ?? {};

  if (block.mode === 'gallery') {
    const images = (block.images ?? [])
      .filter(item => item.imageUrl?.trim())
      .map(item => ({
        src: item.imageUrl,
        alt: resolveGalleryItemAlt(item, lang),
      }));

    if (images.length === 0) return null;

    return (
      <PageBlockShell sx={{ mb: 2 }}>
        <StackedGalleryThumbnail images={images} display={display} />
      </PageBlockShell>
    );
  }

  const src = block.imageUrl?.trim();
  if (!src) return null;

  return (
    <PageBlockShell sx={{ mb: 2 }}>
      <RichTextImage
        src={src}
        alt={resolveImageBlockAlt(block.alt, lang)}
        title={display.title}
        className={imageDisplayOptionsToClassName(display)}
        explicitSx={imageDisplayOptionsToExplicitSx(display)}
      />
    </PageBlockShell>
  );
}
